/*
This code sets the height of an element with the class .offcanvas .middle to be
the full height of the document minus the height of an element with the class 
.offcanvas .top. The height of the offcanvasTop element is calculated using the 
offsetHeight property. The updateOffcanvasMiddleHeight function is called when 
the DOM is finished loading, which is determined by the DOMContentLoaded event.
*/

const offcanvasMiddle = document.querySelector('.offcanvas .middle');
const offcanvasTop = document.querySelector('.offcanvas .top');

const observer = new IntersectionObserver((entries) => {
	// If the offcanvasTop is visible in the viewport
	if (entries[0].isIntersecting) {
		requestAnimationFrame(() => {
			const offcanvasTopHeight = offcanvasTop.offsetHeight;
			offcanvasMiddle.style.height = `calc(100% - ${offcanvasTopHeight}px)`;
		});
		observer.disconnect();
	}
});

if (offcanvasTop) {
	observer.observe(offcanvasTop);
}

document.addEventListener("DOMContentLoaded", () => {
	if (offcanvasTop) {
		observer.observe(offcanvasTop);
	}
});